import { experiments } from '@/utils/experiment/manifest.ts';
import { useExperiment } from '@/utils/experiment/use-experiment.ts';

import { useEligibleForGenericSampleData } from '../controllers';
import { WizardTemplateOption } from '../utils/types';

export type ExperimentKeys = keyof typeof experiments;

export const useIsGenericSampleData = (template: WizardTemplateOption) => {
	const { userEligibleForGenericSampleData } = useEligibleForGenericSampleData(template);

	return {
		genericSampleDataIsEnabled: userEligibleForGenericSampleData,
	};
};

// TWCG-2503: no cohort check. Exposure fires only where this hook renders, which today
// is the Jira-only and Teamwork Collection flows. Reusing these screens elsewhere enrolls those users.
export const useIsStandardizedOnboardingCtas = () => {
	const config = useExperiment(experiments.twcg2503StandardizeJiraOnboardingCtas);
	return config.type === 'enrolled' && config.value;
};
